import React, { Component } from "react";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tabs, Tab } from "react-bootstrap-tabs";

import {
    faBroadcastTower,
    faArrowCircleLeft,
    faAddressBook,
    faCheckCircle,
    faFlag,
    faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import Alert from "../../UI/Alert/Alert";
import Spining from "../../UI/Spining/Spining";
import {
    CAMPAIGN_CONTACT_LIST_API,
    WHATSAPP_TEMPLATE_LIST,
} from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import { Link } from "react-router-dom";
import WhatsAppPreview from "../whatsapp/components/WhatsAppPreview";
import { no_data } from "../../../images/WhatsAppImages";
import {
    getWhatsaAppTemplateList,
    campaignContactList,
    WhstappAccountList,
    createWhatsAppCampaign,
    contactListAPI,
    HOST_URL,
    NODE_HOST_URL,
} from "../api/Api";
import { Helmet } from "react-helmet";
import BillableValue from "./component/BillableValue";
import SetMediaDynamic from "./component/SetMediaDynamic";
import Select from "react-select";
import { withRouter } from 'react-router-dom';
import UploadExcelFile from "./component/UploadExcelFile";
import UploadCSVFile from "./component/UploadCSVFile";
import { Carousel } from 'react-responsive-carousel';
import Axios from 'axios';
import style from './Rcs/rcscampaign.module.css'
import DownloadButton from "./Rcs/SampleCsv";
import DynamicTable from "./DynamicTable";
import BillableModal from "./BillableModal";
import WhatsappFallback from "./WhatsappFallback";
import { FaPlus } from "react-icons/fa";
class TestWhatsAppCampaign extends Component {
    constructor(props) {

        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const userToken = lStorage?.token;
        var today = new Date(),
            date =
                today.getFullYear() +
                "-" +
                (today.getMonth() + 1) +
                "-" +
                ("0" + today.getDate()).slice(-2);
        super(props);
        this.state = {
            user: lStorage?.user,
            user_id: userId,
            token: userToken,
            contactList: "",
            step: 0, // TODO 0
            templatePreView: "",
            previewData: "",
            sampleData: "",
            allWhatsappTemplates: [],
            WhatsappTemplateList: [],
            smsTemplateList: "",
            schedule_datetime: date,
            is_schedule: 0,
            media_url: "",
            brandNumberList: [],
            parameter: [],
            mobile_colum: "",
            tableColume: [],
            varibaleInTemplate: "",
            seleted_brand_number: null,
            CampaignName: "",
            channel: lStorage?.user?.whatsapp_menu === 1 ? "whatsapp" : "",
            templteId: "",
            templateName: "",
            listId: "",
            listType: "",
            SMSmessage: "",
            country_code: 91,
            countryList: [],
            campaignType: "1",
            textnumbers: "",
            numbersArray: [],
            contactListMobile: [],
            fileData: "",
            countData: "",
            uploadProgress: 0,
            smsTemplateDetails: null,
            selectedListName: "",
            totalCount: "",
            isLoading: false,
            isLoadingSampleData: false,
            errorMessage: "",
            isError: false,
            messageType: "",
            billable: "",
            not_billable: "",
            enableCampaign: true,
            option: [],
            contactOption: [],
            urlPath: window.location,
            route: "",
            selectedOption: null,
            dynamicSampleData: [],
            csvHeaders: [],
            filteredHeaders: [],
            csvRows: [],
            mainMsg: '',
            bodyVar: [],
            bodyValue: '',
            variableMapping: {},
            dynamicUrlButtons: [],
            selectedAgents: "all",
            agentList: [],
            previews: [],
            showModal: false,
            campaignAllowed: false,
            showRechargePopup: false,
            templateTypeMessage: "",
            metaCategory: null,
            pannelCategory: null,
            showTemplateTypeModal: false,
            priority1Data: {
                templateId: '',
                templateList: [],
                templateDetails: null,
                message: '',
                templateName: '',
                templatePreView: null,
                paramData: [],
                bodyVariables: [],
                bodyValue: [],
                previewMessage: '',
                channel: '',
                condition: [],
                paramMapping: null,
                status: false,
                paramFlags: []
            },
            priority2Data: {
                templateId: '',
                templateList: [],
                templateDetails: null,
                message: '',
                templateName: '',
                templatePreView: null,
                paramData: [],
                bodyVariables: [],
                bodyValue: [],
                previewMessage: '',
                channel: '',
                condition: [],
                paramMapping: null,
                status: false,
                paramFlags: []
            },
            showForm1: false,
            showForm2: false,
        };
        this.nextStep = this.nextStep.bind(this);
        this.findAndReplace = this.findAndReplace.bind(this);
        this.getCsvData = this.getCsvData.bind(this);
        this.scheduleHandler = this.scheduleHandler.bind(this);
        this.setMediaURL = this.setMediaURL.bind(this);
        this.handleChannel = this.handleChannel.bind(this);
    }

    componentDidMount() {
        const loginData = localStorage.getItem("login");
        if (!loginData) return;

        this.getContactList();
        this.getBrandNumber();
        this.getWhatsaAppTemplateList();
        this.getRoute();
        this.fetchCountryCode();
        this.getAgentList();

    }

    getRoute = async () => {
        try {
            let response = await fetch(`${HOST_URL}/get_user_route.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user_id: this.state.user_id,
                    method: "retrieve",
                    token: this.state.token
                })
            });
            let result = await response.json()
            if (result.success) {
                this.setState({ route: result.data })
            }
        } catch (error) {

        }

    }

    resetTemplateRelatedState = () => {
        this.setState({
            // Template selection
            templteId: "",
            templateName: "",
            templatePreView: "",
            mainMsg: "",
            bodyVar: [],
            varibaleInTemplate: "",
            parameter: [],
            variableMapping: {},
            previews: [],
            dynamicUrlButtons: [],

            // Dynamic mapping
            mobile_colum: "",
            filteredHeaders: [],

            // Fallback
            showForm1: false,
            showForm2: false,
            priority1Data: {
                templateId: '',
                templateList: [],
                templateDetails: null,
                message: '',
                templateName: '',
                templatePreView: null,
                paramData: [],
                bodyVariables: [],
                bodyValue: [],
                previewMessage: '',
                channel: '',
                condition: [],
                paramMapping: null,
                status: false,
                paramFlags: []
            },
            priority2Data: {
                templateId: '',
                templateList: [],
                templateDetails: null,
                message: '',
                templateName: '',
                templatePreView: null,
                paramData: [],
                bodyVariables: [],
                bodyValue: [],
                previewMessage: '',
                channel: '',
                condition: [],
                paramMapping: null,
                status: false,
                paramFlags: []
            }
        });
    };


    getWhatsaAppTemplateList = () => {
        let params = {
            user_id: this.state.user_id,
            method: "retrieve",
            token: this.state.token
        }
        getWhatsaAppTemplateList(params).then((res) => {
            this.setState({ isLoading: true });
            try {
                if (res.data.success === true) {

                    const activeTemplates = res.data.data.filter(
                        item => item.temp_status === 1
                    );

                    const filteredByType = activeTemplates.filter(
                        x =>
                            x.temp_type !== "Carousel" ||
                            (x.temp_type === "Carousel" && x.route_id === 41) ||
                            (x.temp_type === "Carousel" && x.route_id === 36)
                    );

                    this.setState({
                        allWhatsappTemplates: filteredByType,
                        WhatsappTemplateList: filteredByType,
                        option: filteredByType.map(item => ({
                            value: item.id,
                            label: item.temp_name
                        })),
                        isLoading: false
                    });
                }
                else {
                    this.setState({ isLoading: false });
                }
            } catch (error) {
                console.log("error", error);
            }
        });
    };

    fetchCountryCode = async () => {
        const payload = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        }

        try {
            const { data } = await Axios.post(`${HOST_URL}/user_pricelist.php`, payload);
            if (data.success) {

                this.setState({ countryList: [...data.data] })

            } else {
                this.setState({ country_code: "" });
            }

        } catch (error) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "error in fetching country list, please try again later",
            })

        }
    }

    // Method 1: Fetch agent list from API
    getAgentList = async () => {
        if (!this.state.user_id || !this.state.token) return;

        const payload = {
            user_id: this.state.user_id,
            method: "retrieve_agent",
            token: this.state.token,
            user_type: "admin",
            agent_id: this.state.user_id,
        };

        try {
            const { data } = await Axios.post(`${NODE_HOST_URL}/whatsapp_agent`, payload);

            if (data.success) {
                // Filter only agents (exclude managers and teams)
                const agents = data.data.filter(
                    (item) => item.agent_type === "agent" && item.is_active === 1
                );
                this.setState({
                    agentList: agents,
                });
            }
        } catch (error) {
            console.error("Error fetching agents:", error);
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Error fetching agents list. Please try again.",
            });
        }
    };




    handleAgentSelection = (selectedOption) => {
        // Single select now, just store the value directly
        this.setState({
            selectedAgents: selectedOption ? selectedOption.value : "none",
        });
    };




    // nextStep = async () => {
    //   if (this.state.step == 0) {
    //     if (this.state.CampaignName === "" || this.state.channel === "") {
    //       this.setState({
    //         isError: true,
    //         messageType: "alert-danger",
    //         errorMessage: "Please enter all details",
    //         isLoading: false,
    //       });
    //       return false;
    //     } else {
    //       this.setState({
    //         step: this.state.step + 1,
    //         successMessage: false,
    //         isError: false,
    //       });
    //       return true;
    //     }
    //   }

    //   if (this.state.step == 1) {
    //     if (this.state.listId === "" && this.state.textnumbers === "") {
    //       this.setState({
    //         isError: true,
    //         messageType: "alert-danger",
    //         errorMessage: "Please select at list one option",
    //         isLoading: false,
    //       });
    //     } else {
    //       this.setState({
    //         step: this.state.step + 1,
    //         successMessage: false,
    //         isError: false,
    //       });
    //     }
    //   }
    //   this.setState({
    //     step: this.state.step + 1,
    //     successMessage: false,
    //     isError: false,
    //   });
    // };

    mapParamsToState = (paramData, paramValue) => {


        if (!Array.isArray(paramData) || !Array.isArray(paramValue)) {
            console.error("paramData and paramValue must be arrays.");
            return {};
        }
        const processedParamValue = paramValue
            .map(value => value.replace(/\[|\]/g, ''))
            .map(value => value.replace(/^\{\{|\}\}$/g, ''));
        // Map the two arrays into an object
        return paramData.reduce((acc, key, idx) => {
            acc[key] = processedParamValue[idx] !== undefined ? processedParamValue[idx] : null; // Default to null for missing values
            return acc;
        }, {});
    };
    isDynamic = (priorityType) => {
        const { priority1Data, priority2Data } = this.state;

        let isDynamicFlag = false;

        if (priorityType === 'priority1') {
            isDynamicFlag = priority1Data.paramFlags?.some(flag => Object.values(flag)[0] === true);
        } else if (priorityType === 'priority2') {
            isDynamicFlag = priority2Data.paramFlags?.some(flag => Object.values(flag)[0] === true);
        }

        return isDynamicFlag ? 1 : 0; // Return 1 if dynamic, otherwise 0
    };
    onNameChange = (e) => {
        this.setState({ CampaignName: e.target.value });
        this.setState({ isError: false });
    };

    isValid = () => {
        const { varibaleInTemplate, campaignType,
            country_code, variableMapping,
            mobile_colum, bodyValue,
            step, channel,
            CampaignName,
            seleted_brand_number,
            dynamicUrlButtons,
        } = this.state;

        if (channel === "") {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please select channel",
                isLoading: false,
            });
            return false;
        }
        if (country_code === "") {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please select a country",
                isLoading: false,
            });
            return false;
        }
        // ✅ Basic Validation (Name and Brand Number)
        if (!seleted_brand_number) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please select a brand number",
                isLoading: false,
            });
            return false;
        }

        if (!CampaignName) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please enter a campaign name",
                isLoading: false,
            });
            return false;
        }


        // ✅ Validate for Campaign Type 3 (Column Selection)
        if (campaignType === "3" && step === 2) {
            for (let item of varibaleInTemplate) {
                const key = `{{${item}}}`;

                // Check if mobile column is selected
                if (item === "mobile" && !mobile_colum) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: "Please select the mobile column",
                        isLoading: false,
                    });
                    return false;
                }

                // Check if all required columns are mapped
                if (item !== "mobile" && (!variableMapping[key] || variableMapping[key].trim() === "")) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: `Please select a column for variable ${item}`,
                        isLoading: false,
                    });
                    return false;
                }
            }
        }

        // ✅ Validate for Campaign Type 1 (Fixed Values)
        if (campaignType === "1" && step === 2) {
            for (let item of varibaleInTemplate) {
                if (item !== "mobile" && (!bodyValue[item] || bodyValue[item].trim() === "")) {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: `Please enter a value for variable ${item}`,
                        isLoading: false,
                    });
                    return false;
                }
            }
        }

        // ✅ Validate dynamic URL button(s): column selected for type "3", typed value for type "1"
        if (step === 2 && dynamicUrlButtons?.length > 0) {
            for (let btn of dynamicUrlButtons) {
                if (!btn.mappedValue || `${btn.mappedValue}`.trim() === "") {
                    this.setState({
                        isError: true,
                        messageType: "alert-danger",
                        errorMessage: campaignType === "3"
                            ? `Please select a column for button "${this.getButtonTitle(btn)}"`
                            : `Please enter a value for button "${this.getButtonTitle(btn)}"`,
                        isLoading: false,
                    });
                    return false;
                }
            }
        }

        // ✅ If all checks pass, return true
        return true;
    };

    handleModalClose = () => {
        this.setState({ showModal: false });
    };


    clearError = () => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",

        })
    }

    nextStep = async () => {
        if (this.isValid()) {
            this.setState({
                step: this.state.step + 1,
            });
        }
    };

    prevStep = () => {
        this.setState({ step: this.state.step - 1 });
    };

    getContactList = () => {
        let params = {
            user_id: this.state.user_id,
            method: "retrieve",
            token: this.state.token
        }
        contactListAPI(params).then((res) => {
            if (res.data.success === true) {
                let ctList = res.data.data;
                ctList.forEach((item) => {
                    let newCtData = { value: item.id, label: `${item.name}(${item.number_count})` };
                    this.setState((prevState) => ({
                        contactOption: [...prevState.contactOption, newCtData],
                    }));
                });
                this.setState({
                    contactList: res.data.data,
                    isLoading: false,
                });
            } else {
                this.setState({ ErrorResponse: res.data, isLoading: false });
            }
        });
    };

    // Helper to build customisedata based on listType and countrycode
    buildCustomiseData = () => {
        const { previewData, countData, campaignType, listType, country_code } = this.state;

        // Guard: ensure previewData is a valid array
        if (!previewData || !Array.isArray(previewData) || previewData.length === 0) {
            return null;
        }

        // Only apply new logic when listType is NOT "contact"
        if (listType !== "contact") {

            if (country_code == 99999) {
                // MULTI: prepend each object's own country_code to mobile
                return previewData.map((item) => ({
                    ...item,
                    mobile: `${item.country_code}${item.mobile}`,
                }));
            } else {
                // SINGLE: filter by selected country_code, then prepend
                return previewData
                    .filter((item) => item.country_code === parseInt(country_code))
                    .map((item) => ({
                        ...item,
                        mobile: `${item.country_code}${item.mobile}`,
                    }));
            }
        }

        // listType === "contact" — existing logic untouched
        return null;
    };

    createCampaign = async () => {
        this.setState({ isLoading: true });

        const newArr = [{ id: this?.state?.selectedOption?.value }];

        let formattedVariableMapping;
        let parameterObject;
        if (this.state.campaignType === "3" && this.state.listId && this.state.listType === "contact") {
            formattedVariableMapping = Object.fromEntries(
                Object.entries(this.state.variableMapping).map(([key, value]) => [
                    key.replace(/^\{\{|\}\}$/g, ""), // Remove double curly braces
                    `${value}` // Convert to lowercase and add #
                ])
            );
            parameterObject = [{ ...formattedVariableMapping }]
        } else {
            formattedVariableMapping = Object.fromEntries(
                Object.entries(this.state.variableMapping).map(([key, value]) => [
                    key.replace(/^\{\{|\}\}$/g, ""), // Remove double curly braces
                    `#${value}#` // Convert to lowercase and add #
                ])
            );
            parameterObject = { body: { ...formattedVariableMapping }, header: {} }
        }

        // Button title -> value map for dynamic URL buttons (both buttons share one object). campaignType "1": raw typed value. campaignType "3": csv/contact column wrapped in #...#
        const buttonParam = (this.state.dynamicUrlButtons || []).reduce((acc, btn) => {
            const title = this.getButtonTitle(btn);
            if (!title) return acc;
            const value = btn.mappedValue || "";
            acc[title] = this.state.campaignType === "3" ? `#${value}#` : value;
            return acc;
        }, {});

        const fb_condition = [
            {
                condition: this.state.priority1Data.condition,
                channel: this.state.priority1Data.channel,
                templateId: this.state.priority1Data.templateId,
                paramMapping: this.mapParamsToState(this.state.priority1Data.paramData, this.state.priority1Data.bodyValue),
                is_dynamic: this.isDynamic('priority1'),
            },
            // {
            //     condition: this.state.priority2Data.condition,
            //     channel: this.state.priority2Data.channel,
            //     templateId: this.state.priority2Data.templateId,
            //     paramMapping: this.mapParamsToState(this.state.priority2Data.paramData, this.state.priority2Data.bodyValue),
            //     is_dynamic: this.isDynamic('priority2')
            // }
        ]

        // ✅ Create FormData Object
        let formData = new FormData();

        // ✅ Append all key-value pairs
        formData.append("token", this.state.token);
        formData.append("user_id", this.state.user_id);
        formData.append("channel", this.state.channel);
        formData.append("template_id", this.state.templteId);
        formData.append("list_id", this.state.listId);
        formData.append("country_code", this.state.country_code);
        formData.append(
            "parameter",
            JSON.stringify(this.state.campaignType === "1" ? this.state.parameter : parameterObject)
        ); // Convert object to JSON string
        formData.append("button_param", JSON.stringify(buttonParam));
        formData.append("mobile_colum", this.state.mobile_colum);
        formData.append("camp_name", this.state.CampaignName);
        formData.append("media_url", this.state.media_url || "");
        formData.append("total_count", this.state.numbersArray?.length + this.state.countData?.length + this.state.totalCount);
        formData.append("brand_number", this.state.seleted_brand_number);
        formData.append("schedule_datetime", this.state.schedule_datetime);
        formData.append("is_schedule", this.state.is_schedule);
        formData.append("method", "create_new");
        formData.append("textnumbers",  [...this.state.numbersArray,...this.state.contactListMobile]);
        formData.append(
            "contact_list",
            JSON.stringify(this.state.selectedOption ? newArr : [])
        );
        formData.append("campaign_type", this.state.campaignType);
        formData.append("dynamic_content", this.state.bodyVar.length > 0 ? 1 : 0);

        // ✅ Append File if Exists
        if (this.state.fileData && this.state.campaignType === "1") {
            formData.append("uploadcsv", this.state.fileData);
        }
        // if (this.state.fileData && this.state.campaignType === "3") {
        //     const countDataJson = JSON.stringify(this.state.countData);
        //     formData.append("customise_data", countDataJson);
        // }
        // if (this.state.previewData && this.state.campaignType === "3") {
        //     const previewDataJson = JSON.stringify(this.state.previewData);
        //     formData.append("customise_data", previewDataJson);
        // }

        if (this.state.campaignType === "3") {
            console.log("previewData:", this.state.previewData, "listType:", this.state.listType);
            const nonContactCustomise = this.buildCustomiseData();

            if (nonContactCustomise !== null) {


                // listType !== "contact" — use modified previewData with country code in mobile
                formData.append("customise_data", JSON.stringify(nonContactCustomise));
            } else if (this.state.fileData) {

                // listType === "contact" with file upload — existing logic
                formData.append("customise_data", JSON.stringify(this.state.countData));
            } else if (this.state.previewData) {

                // listType === "contact" with contact list — existing logic
                formData.append("customise_data", JSON.stringify(this.state.previewData));
            }
        }
        formData.append("fb_condition", JSON.stringify(fb_condition));
        formData.append(
            "is_fallback",
            (this.state.priority1Data.status || this.state.priority2Data.status) ? 1 : 0
        );

        formData.append(
            "agent_ids",
            this.state.selectedAgents === "all" || this.state.selectedAgents === "none"
                ? this.state.selectedAgents          // sends "all" or "none" as string
                : JSON.stringify(this.state.selectedAgents)  // sends [id] as JSON array
        );

        // const debugPayload = {};
        // for (let pair of formData.entries()) {
        //     debugPayload[pair[0]] = pair[1];
        // }

        // console.log("WHATSAPP CAMPAIGN PAYLOAD =>", debugPayload);
        // return
        try {
            const res = await Axios.post(`${HOST_URL}/bulk_campaign_whatsapp_as.php`, formData, {
                timeout: 0,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    this.setState({ uploadProgress: progress }); // Update progress in state
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (res.data.success) {
                const { billable, not_billable } = res.data;
                this.setState({
                    isError: true,
                    messageType: "alert-success",
                    errorMessage: res.data.message,
                    billable: billable,
                    not_billable: not_billable,
                    showModal: true,
                });
            } else {
                this.setState({
                    isError: true,
                    messageType: "alert-danger",
                    errorMessage: res.data.message,

                });
            }
        } catch (error) {
            console.error('Error uploading campaign:', error);

            const statusCode = error.response?.status;
            let messageType = "alert-danger";
            let errorMsg = `${statusCode ? `[${statusCode}] ` : ''}${error.response?.data?.message || "An error occurred while creating the campaign."}`;

            if (statusCode === 404) {
                messageType = "alert-warning";
                errorMsg = "Campaign status could not be confirmed. Please review the campaign report for final details.";
                this.setState({
                    showModal: true,
                });
            }


            this.setState({
                isError: true,
                messageType,
                errorMessage: errorMsg,
                isLoading: false,
            });
        }
        finally {
            this.setState({ isLoading: false })
        }
    };


    enableCampaingButton = (value) => {
        this.setState({
            enableCampaign: value,
        });
    };

    getBrandNumber = async () => {
        let paramData = {
            user_id: this.state.user_id,
            token: this.state.token,
            method: "retrieve",
        }
        WhstappAccountList(paramData).then((res) => {
            if (res.data.success === true) {
                this.setState({ brandNumberList: res.data.data });
            } else {
                this.setState({ ErrorResponse: res.data.data });
            }
        });
    };

    verifyTemplateType = async (templateId) => {
        try {
            const payload = {
                user_id: this.state.user_id,
                token: this.state.token,
                method: "check_template_status_bycamp",
                template_id: templateId
            }

            const { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, payload);
            if (!data.success) {

                this.setState({

                    templateTypeMessage: data.message,
                    metaCategory: data.meta_category,
                    pannelCategory: data.pannel_category,
                })
                if (data.meta_category !== data.pannel_category) {
                    this.setState({ showTemplateTypeModal: true })
                } else {
                    this.setState({ showTemplateTypeModal: false })
                }
            }


        } catch (error) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: `${error.response?.data?.message || "Error in verifying template type, please try again later"}`,
            })
        }
    }

    selectedWhatsAppTemplate = async (e) => {
        this.setState({ templteId: e.value, templateName: e.label });
        this.setState({
            bodyValue: '',
            parameter: [],
            bodyVar: [],
            mainMsg: '',
            variableMapping: {},
            previews: [],
            dynamicUrlButtons: [],

        })
        try {
            const { data } = await api.post(WHATSAPP_TEMPLATE_LIST, {
                token: this.state.token,
                user_id: this.state.user_id,
                id: e.value,
                method: "retrieveid",
            });
            let urlbtn = [];
            let urlbtn2 = [];
            let callbtn = [];
            let button1 = [];
            let button2 = [];
            let button3 = [];
            if (data.success === true) {
                if (data.data[0].temp_type === "Carousel") {
                    const template = data.data[0];
                    let mediaUrls = [];
                    if (template.media_url && template.media_url !== "[]") {
                        try {
                            mediaUrls = JSON.parse(template.media_url);
                        } catch (err) {
                            console.warn("Invalid media_url format", err);
                        }
                    }

                    const carouselMapped = {
                        tampleName: template.temp_name,
                        temp_body: template.temp_body,
                        templateType: template.temp_type,
                        cards: template.temp_button.cards.map((card, index) => {
                            const header = card.components.find(c => c.type === "HEADER");
                            const body = card.components.find(c => c.type === "BODY");
                            const buttons = card.components.find(c => c.type === "BUTTONS");

                            return {
                                header_image_handle: mediaUrls[index] || null,
                                body_text: body?.text || "",
                                buttons: buttons?.buttons.map(b => ({
                                    text: b.text,
                                    type: b.type
                                })) || []
                            };
                        })
                    };

                    this.extractData(data.data[0].temp_body)
                    const bodyVariables = data.data[0].temp_body.match(/\*?\{\{([^}]+)\}\}\*?/g) || [];

                    this.getVariable(data.data[0].temp_body);
                    this.setState({
                        templatePreView: carouselMapped,
                        mainMsg: template.temp_body,
                        bodyVar: [...bodyVariables]
                    });

                    return;
                }


                if (data.data[0].temp_button) {
                    let buttonData = data.data[0].temp_button;
                    buttonData.map((item, index) => {
                        let key = Object.keys(item);
                        if (key.includes("urltext2")) {
                            urlbtn2[0] = item;
                        }
                        if (key.includes("urltext")) {
                            urlbtn[0] = item;
                        }
                        if (key.includes("phone")) {
                            callbtn[0] = item;
                        }
                        if (key.includes("button1")) {
                            button1[0] = item;
                        }
                        if (key.includes("button2")) {
                            button2[0] = item;
                        }
                        if (key.includes("button3")) {
                            button3[0] = item;
                        }
                    });
                }

                const dynamicUrlButtons = this.getDynamicUrlButtons(data.data[0].temp_button);

                let PreviewTemplateData = {
                    tampleName: data.data[0].temp_name,
                    language: data.data[0].temp_language,
                    accountType: data.data[0].temp_category,
                    templateType: data.data[0].temp_type,
                    headerText: data.data[0].temp_header,
                    headerOptions: data.data[0].temp_header === "" ? false : true,
                    footerText: data.data[0].temp_footer,
                    footerOptions: data.data[0].temp_header === "" ? false : true,
                    temp_button: data.data[0].temp_button,
                    bodyMessage: data.data[0].temp_body,
                    button: data.data[0].temp_button,
                    temp_status: data.data[0].temp_status,
                    Urlbutton: urlbtn,
                    Urlbutton2: urlbtn2,
                    Callbutton: callbtn,
                    button1: button1,
                    button2: button2,
                    button3: button3,
                    quickButton:
                        data.data[0].temp_button?.length > 0 &&
                            data.data[0].temp_button[0].actionType === "quickReply"
                            ? [data.data[0].temp_button[0]]
                            : "",
                    temp_attribute: [],
                    isLoading: false,
                };

                this.extractData(data.data[0].temp_body)
                const bodyVariables = data.data[0].temp_body.match(/\*?\{\{([^}]+)\}\}\*?/g) || [];

                this.getVariable(data.data[0].temp_body);
                this.setState({
                    templatePreView: PreviewTemplateData,
                    mainMsg: data.data[0].temp_body,
                    bodyVar: [...bodyVariables],
                    dynamicUrlButtons,
                });
                const template = data.data[0];
                const facebookTemplateId = template.facebook_tempid;

                this.mediaTemplate(PreviewTemplateData);
                await this.verifyTemplateType(facebookTemplateId);
            }
        } catch (err) {
            console.log(err);
        }
    };

    getVariable = (data) => {
        var regex = /{{([^}]+)}}/g;
        let m;
        var tempArr = ["mobile"];
        var parameter = {};
        while ((m = regex.exec(data)) !== null) {
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            parameter[`${m[1]}`] = "";
            tempArr.push(m[1]);
        }
        this.setState({
            varibaleInTemplate: tempArr,
            parameter: [...this.state.parameter, parameter],
        });
    };

    setParameter = (e) => {
        this.state.parameter.map((item, i) => {
            Object.keys(item).map((key) => {
                if (key === e.target.name) {
                    let obj = (this.state.parameter[i][key] = e.target.value);
                    this.findAndReplace(e.target.name, obj);
                } else {
                    console.log("something went wrong");
                }
            });
        });
    };

    handleMobileColumnSelect = (e) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
            mobile_colum: e.target.value
        })

    }

    // Finds every call-to-action button whose URL type is "Dynamic" (skips static URL buttons); a template can have up to 2 URL buttons (urltext/urltext2)
    getDynamicUrlButtons = (buttonData) => {
        if (!Array.isArray(buttonData)) return [];
        return buttonData.filter(
            (item) =>
                item.actionType === "calltoaction" &&
                item.urlType?.toLowerCase() === "dynamic"
        );
    };

    // The 2nd URL button's title comes back under "urltext2" instead of "urltext"
    getButtonTitle = (btn) => btn?.urltext || btn?.urltext2 || "";

    // Stores the entered value (campaignType "1") or selected column (campaignType "3") on the button object itself, by its index within dynamicUrlButtons
    setDynamicUrlButtonValue = (index, mappedValue) => {
        this.setState((prevState) => {
            const updatedButtons = [...prevState.dynamicUrlButtons];
            updatedButtons[index] = {
                ...updatedButtons[index],
                mappedValue,
            };
            return {
                isError: false,
                messageType: "",
                errorMessage: "",
                dynamicUrlButtons: updatedButtons,
            };
        });
    };

    handleButtonUrlValueChange = (index, e) => {
        this.setDynamicUrlButtonValue(index, e.target.value);
    };

    handleButtonUrlMapping = (index, e) => {
        this.setDynamicUrlButtonValue(index, e.target.value);
    };

    handleMapping = (variable, selectedHeader) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
        })
        this.setState(
            (prevState) => {
                // Update the variable mapping with the new key-value pair
                const updatedVariableMapping = {
                    ...prevState.variableMapping,
                    [variable]: selectedHeader,
                };

                // Remove the previous value for this variable from filteredHeaders
                const updatedFilteredHeaders = prevState.filteredHeaders.filter(
                    (header) => header !== prevState.variableMapping[variable]
                );

                // Check if selectedHeader is already in filteredHeaders
                if (!updatedFilteredHeaders.includes(selectedHeader)) {
                    // Add the new selectedHeader only if it's not already in the array
                    updatedFilteredHeaders.push(selectedHeader);
                }

                return {
                    variableMapping: updatedVariableMapping,
                    filteredHeaders: updatedFilteredHeaders,

                };
            },
            () => {

                // Generate previews after mapping is updated


                const previews = this.generatePreviews();
                this.setState({
                    previews: previews.map((item) => ({
                        ...this.state.templatePreView, // Spread existing object
                        bodyMessage: item, // Update the property
                    })),
                });


            }
        );
    }


    generatePreviews() {
        const { csvRows, variableMapping, mainMsg, csvHeaders } = this.state;

        return csvRows.map((row) => {
            let previewString = mainMsg; // ✅ Keep this string for replacement logic
            const spans = []; // ✅ Store JSX spans separately

            // Process each variable in the mapping
            Object.keys(variableMapping).forEach((variable) => {
                const header = variableMapping[variable];
                const columnIndex = csvHeaders.indexOf(header);

                if (columnIndex !== -1) {
                    const value = row[columnIndex];

                    // ✅ Check if `*variable*` exists, else use `variable`
                    const boldKey = `*${variable}*`;
                    const normalKey = `${variable}`;

                    let splitKey = null;
                    if (previewString.includes(boldKey)) {
                        splitKey = boldKey; // Use `*variable*`
                    } else if (previewString.includes(normalKey)) {
                        splitKey = normalKey; // Use `variable`
                    }

                    if (splitKey) {
                        // ✅ Replace with a temporary marker
                        previewString = previewString.replace(splitKey, `[SPAN-${variable}]`);

                        // ✅ Store JSX data separately
                        spans.push({
                            key: variable,
                            value,
                            isBold: splitKey === boldKey, // ✅ Bold only if it was `*variable*`
                        });
                    }
                }
            });

            // ✅ Convert placeholders into JSX
            const finalPreview = previewString.split(/(\[SPAN-.*?\])/).map((part, index) => {
                const match = part.match(/\[SPAN-(.*?)\]/);
                if (match) {
                    const variable = match[1];
                    const spanData = spans.find((s) => s.key === variable);
                    return (
                        <span key={index} style={{ color: "blue", fontWeight: spanData.isBold ? "bold" : "normal" }}>
                            {spanData.value}
                        </span>
                    );
                }
                return part; // Keep normal text
            });

            return finalPreview; // ✅ Return JSX safely
        });
    }

    getColumedata = (id) => {
        let params = {
            user_id: this.state.user_id,
            method: "retrieve_data",
            token: this.state.token,
            list_id: id
        }
        campaignContactList(params).then((res) => {
            this.setState({ isLoading: true });
            try {
                if (res.data.success === true) {
                    const mobileNumbers = (res.data.data || []).map(item => String(item.mobile));
                    this.setState({
                        tableColume: Object.keys(res.data.data[0]),
                        previewData: res.data.data,
                        isLoading: false,
                        contactListMobile: mobileNumbers,
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            } catch (error) {
                console.log("error", error);
            }
        });
    };

    clearTemplatePreview = () => {
        if (this.state.templteId) {
            this.setState({
                templteId: "",
                templateName: "",
                templatePreView: "",
                mainMsg: '',
                bodyVar: [],
                varibaleInTemplate: "",
                parameter: [],
                variableMapping: {},
                previews: [],

            })

        }
    }

    handleCampaignType = (e) => {
        this.setState({
            campaignType: e.target.value,
            textnumbers: "",
            numbersArray: [],
            totalCount: "",
        })
        if (this.state.selectedOption) {
            this.setState({
                selectedOption: null, listId: "",
                selectedListName: ""
            })
        }
        if (this.state.fileData) {
            this.setState({
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                csvHeaders: [],
                filteredHeaders: [],
                csvRows: [],
            })
        }

        this.clearTemplatePreview();

    }


    // onChange = (e) => {

    //     this.clearTemplatePreview();
    //     const value = e.target.value;
    //     // Allow only numbers and commas
    //     const validValue = value.replace(/[^0-9\n]/g, '');
    //     if (value !== validValue) {
    //         this.setState({
    //             isError: true,
    //             messageType: "alert-danger",
    //             errorMessage: "Please enter a valid input containing only numbers",
    //             isLoading: false,
    //         });
    //     } else {
    //         this.setState({ isError: false, errorMessage: "", messageType: "" });
    //     }
    //     this.setState({ textnumbers: validValue });
    //     this.newArray(validValue);
    // };

    onChange = (e) => {
        this.clearTemplatePreview();
        const value = e.target.value;

        // Allow only numbers and newlines
        const validValue = value.replace(/[^0-9\n]/g, '');
        if (value !== validValue) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "Please enter a valid input containing only numbers",
                isLoading: false,
            });
            return; // stop further processing
        }

        // Split by newlines and filter out empty lines
        const numbersArray = validValue.split("\n").filter(num => num.trim() !== "");

        // Check if more than 100,000 numbers
        if (numbersArray.length > 100000) {
            this.setState({
                isError: true,
                messageType: "alert-danger",
                errorMessage: "You can enter a maximum of 1,00,000 numbers. Use csv for more numbers",
                isLoading: false,
            });
            return;
        }

        // If valid
        this.setState({
            isError: false,
            errorMessage: "",
            messageType: "",
            textnumbers: validValue
        });

        this.newArray(validValue);
    };

    newArray = (data) => {
        const numbers = data.split(/\n+/)
            .map((num) => num.trim())
            .filter((num) => num !== "");
        this.setState({ numbersArray: numbers });
    };

    contactListhandler = (e) => {
        if (!e) {
            // When cleared, reset state
            this.setState({
                selectedOption: null,
                textnumbers: "",
                numbersArray: [],
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                selectedListName: "",
                totalCount: 0,
                listId: "",
            });
            this.clearTemplatePreview();
            return;
        }

        // When a valid option is selected
        this.setState({
            selectedOption: e,
            //  textnumbers: "", numbersArray: [] 
        });

        if (this.state.fileData && this.state.campaignType === "3") {
            this.setState({
                fileData: "",
                sampleData: "",
                countData: "",
                tableColume: [],
                dynamicSampleData: [],
                mobile_colum: ""
            });
        }

        this.clearTemplatePreview();
        this.setState({ listId: e.value });

        var item = this.state.contactList.filter(
            (item) => item.id === parseInt(e.value)
        );

        this.setState({
            selectedListName: item[0]?.name || "", // Use optional chaining to prevent errors
            totalCount: item[0]?.number_count || 0, // Default to 0 if not found
        });

        this.getColumedata(e.value);
        this.getSampleData(e.value);
    };


    getSampleData = async (id) => {
        const excludedFields = ["_id", "created", "status", "list_id", "user_id"];

        try {
            this.setState({ isLoadingSampleData: true });
            const { data } = await api.post(CAMPAIGN_CONTACT_LIST_API, {
                token: this.state.token,
                user_id: this.state.user_id,
                list_id: id,
                method: "retrieve_data_sample",
            });

            if (data.success === true) {
                // Filter out excluded fields from each object
                const filteredData = data.data
                    .map((item) =>
                        Object.fromEntries(
                            Object.entries(item).filter(([key]) => !excludedFields.includes(key))
                        )
                    ).slice(0, 5) // Limit to first 5 entries;

                const csvHeaders = filteredData[0]
                    ? Object.keys(filteredData[0]).map((header) => header.trim())
                    : [];

                const csvRows = filteredData.map((item) => Object.values(item));

                this.setState({
                    sampleData: filteredData,
                    csvHeaders: csvHeaders,
                    csvRows: csvRows,
                    isLoadingSampleData: false,
                    listType: data.list_type
                });
            } else {
                this.setState({ ErrorResponse: data, isLoadingSampleData: false });
            }
        } catch (err) {
            console.log(err);
            this.setState({ isLoadingSampleData: false });
        }
    };

    extractData = (data) => {
        const pattern = /\*?\{\{([^}]+)\}\}\*?/g;
        const matches = [];
        let match;
        while ((match = pattern.exec(data)) !== null) {
            matches.push(match[1]);
        }

        return matches;
    };

    replaceBodyVal = (index, e) => {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
        })
        const updatedValues = { ...this.state.bodyValue };
        updatedValues[e.target.name] = e.target.value;

        this.setState({ bodyValue: updatedValues, parameter: updatedValues });

        if (this.state.templatePreView.templateType !== "Carousel") {
            const bodydata = this.formatMessage(
                this.state.mainMsg,
                this.state.bodyVar,
                updatedValues
            );

            this.setState({
                templatePreView: {
                    ...this.state.templatePreView,
                    ["bodyMessage"]: bodydata,
                },
            });

        } else if (this.state.templatePreView.templateType === "Carousel") {
            const bodydata = this.formatMessage(
                this.state.mainMsg,
                this.state.bodyVar,
                updatedValues
            );

            this.setState({
                templatePreView: {
                    ...this.state.templatePreView,
                    ["bodyMessage"]: bodydata,
                },
            });

        }



    };

    formatMessage = (msg, placeholders, inputValues) => {
        const parts = msg.split(/\*?\{\{([^}]+)\}\}\*?/g);
        return parts.map((part, index) => {
            const placeholderKey = part;
            if (placeholders.includes(`{{${placeholderKey}}}`)
            ) {
                return (
                    <span key={index} style={{
                        color: inputValues[placeholderKey] ? "blue" : "", // Blue for input values, black for placeholders
                    }}>
                        {inputValues[placeholderKey] || `{{${part}}}`}
                    </span>
                );
            }
            if (placeholders.includes(`*{{${placeholderKey}}}*`)
            ) {
                return (
                    <span key={index} style={{
                        color: inputValues[placeholderKey] ? "blue" : "", // Blue for input values, black for placeholders
                        fontWeight: inputValues[placeholderKey] ? "bold" : "",
                    }}>
                        {inputValues[placeholderKey] || `*{{${part}}}*`}
                    </span>
                );
            }
            return part;
        });
    };

    renderSampleData = () => {
        const { sampleData: data, isLoadingSampleData } = this.state; // ← changed

        if (isLoadingSampleData) { // ← changed
            return (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "120px"
                }}>
                    <div
                        className="spinner-border text-primary"
                        role="status"
                        style={{ width: "2rem", height: "2rem" }}
                    >
                        <span className="sr-only">Loading...</span>
                    </div>
                    <span style={{ marginLeft: "10px", color: "#6c757d" }}>
                        Loading contact data...
                    </span>
                </div>
            );
        }

        if (data?.length > 0) {
            const column = Object.keys(data[0]);
            return (
                <>

                    <table className="table table-hover my-0">
                        <thead>
                            <tr>
                                {column.map((col, i) => (
                                    <th key={i}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, i) => (
                                <tr key={i}>
                                    {column.map((col, j) => (
                                        <td key={j}>{row[col]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            );
        }

        return <p>No data available</p>;
    };

    handleAddForm = () => {
        this.setState((prevState) => {
            if (!prevState.showForm1) {
                return { showForm1: true };
            }
            else if (!prevState.showForm2) {
                return { showForm2: true };
            }
            return null; // Maximum 2 forms allowed
        });
    };

    // Handler to update priority1Data
    setPriority1Data = (updatedData) => {
        this.setState({ priority1Data: { ...this.state.priority1Data, ...updatedData } });
    };

    // Handler to update priority2Data
    setPriority2Data = (updatedData) => {
        this.setState({ priority2Data: { ...this.state.priority2Data, ...updatedData } });
    };

    findAndReplace = (name, column) => {
        let text = this.state.templatePreView.bodyMessage;
        let replaceKeyword = `{{${name}}}`;
        let value = this.state.sampleData[0][column];
        let newtext = text.replace(replaceKeyword, value);
        let obj = (this.state.templatePreView["temp_body"] = newtext);
        this.setState({
            templatePreView: {
                ...this.state.templatePreView,
                ["bodyMessage"]: newtext,
            },
        });
    };

    getCsvData(data, countData) {
        const trimmedCountData = countData.map(item => {
            const trimmedObj = {};
            Object.keys(item).forEach(key => {
                trimmedObj[key.trim()] = item[key];  // Trim key here
            });
            return trimmedObj;
        });
        if (this.state.selectedOption && this.state.campaignType === "3") {
            this.setState({
                selectedOption: null,
                listId: "",
                sampleData: "",
                previewData: "",
                selectedListName: "",
                totalCount: "",
                mobile_colum: ""
            })
        }
        // if (this.state.textnumbers) {
        //     this.setState({ textnumbers: "", numbersArray: [] })
        // }
        this.clearTemplatePreview();
        this.setState({
            // sampleData: data.rowData,
            fileData: data,
            countData: [...trimmedCountData],
            tableColume: data.tableColume,
            dynamicSampleData: trimmedCountData.splice(0, 5),
        });
        this.setCsvData();
    }

    setCsvData = () => {
        const { dynamicSampleData } = this.state;

        // Extract headers and data
        const csvHeaders = dynamicSampleData[0]
            ? Object.keys(dynamicSampleData[0]).map((header) => header.trim())
            : [];

        this.setState({ csvHeaders: csvHeaders })
        const csvRows = dynamicSampleData.map((item) => Object.values(item));
        this.setState({ csvRows: csvRows })
    }

    setLoading = (value) => {
        this.setState({ isLoading: value })
    }

    setUploadProgress = (value) => {
        this.setState({ uploadProgress: value })
    }

    scheduleHandler(e) {
        if (e.target.checked === true) {
            this.setState({ is_schedule: 1 });
        } else {
            this.setState({ is_schedule: 0 });
        }
    }

    mediaTemplate() {
        let data = this.state.templatePreView;
        if (data != "" && data != undefined) {
            const hasKey = "image" in data;
            if (hasKey) {
                console.log("The key exists.");
            } else {
                console.log("The key does not exist.");
            }
        }
    }

    setMediaURL(data) {
        let newTemplate = { ...this.state.templatePreView };
        let objectkey = Object.keys(this.state.templatePreView.headerText)[0];
        if (data) {
            newTemplate.headerText[objectkey] = data;
        }

        this.setState({
            media_url: data,
        });
    }

    handleChannel(e) {
        this.setState({
            isError: false,
            messageType: "",
            errorMessage: "",
            isLoading: false,
        });
        const { pathname } = this.state.urlPath;
        const segments = pathname.split("/");
        const endPath = segments[segments.length - 1];
        const selectedChannel = e.target.value;

        if (selectedChannel === "whatsapp") {
            if (endPath === "campaign-start") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/campaign-start");
            }
        }

        if (selectedChannel === "sms") {
            if (endPath === "sms-campaign") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/sms-campaign");
            }
        }

        if (selectedChannel === "rcs") {
            if (endPath === "rcs-campaign") {
                this.setState({ channel: selectedChannel });
            } else {
                this.props.history.push("/dashboard/rcs-campaign");
            }
        }
    }

    formRender = () => {
        switch (this.state.step) {
            case 1:
                return (
                    <>
                        <div className="filter-option">
                            <div></div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="d-flex align-items-start justify-content-between">
                                        <div>
                                            Choose Audience to send the campaign on
                                            <span className="text-primary"> {this.state.channel} </span>
                                        </div>


                                    </div>
                                    <div>
                                        <div>
                                            {this.state.campaignType === "1" &&
                                                <Tabs id="fall-back-tab">
                                                    <Tab label="Copy Paste Data">
                                                        <div className="input-group flex flex-column mb-2 mt-4 mr-sm-2">
                                                            <p style={{ fontSize: '.8rem', color: 'red', wordBreak: "break-all" }}>
                                                                *Enter mobile number{' '}
                                                                {this.state.country_code === 99999
                                                                    ? '(with country code)'
                                                                    : '(without country code)'}{' '}
                                                                in new line
                                                            </p>
                                                            <textarea
                                                                placeholder="Enter Mobile Number"
                                                                onChange={this.onChange}
                                                                defaultValue={this.state.textnumbers}
                                                                className="form-control w-100"
                                                                rows={5}
                                                            ></textarea>
                                                        </div>
                                                        <span style={{ float: "right" }}>
                                                            count: {this.state.numbersArray.length + this.state.countData.length}
                                                        </span>
                                                    </Tab>
                                                    <Tab label="Select From Contact List">
                                                        {this.state.contactList ? (
                                                            <div className="input-group drop-down-icons mb-2 mt-4 mr-sm-2">
                                                                <Select
                                                                    value={this.state.selectedOption}
                                                                    onChange={this.contactListhandler}
                                                                    options={this.state.contactOption}
                                                                    isSearchable={true}
                                                                    placeholder="Select Contact List"
                                                                    isClearable={true}
                                                                />

                                                            </div>
                                                        ) : (
                                                            <p className="alert alert-danger d-block">
                                                                You don't have any contacts please create{" "}
                                                                <Link to="/dashboard/contact-list">Contacts</Link>{" "}
                                                                and then come back.
                                                            </p>
                                                        )}
                                                    </Tab>

                                                    <Tab label="Upload .csv File">
                                                        <UploadCSVFile sendCsvData={this.getCsvData} setLoading={this.setLoading} />
                                                        <DownloadButton campaignType={this.state.campaignType} countryCode={this.state.country_code} />
                                                    </Tab>
                                                </Tabs>}
                                            {this.state.campaignType === "3" &&
                                                <Tabs id="fall-back-tab">
                                                    <Tab label="Select From Contact List">
                                                        {this.state.contactList ? (
                                                            <div className="input-group drop-down-icons mb-2 mt-4 mr-sm-2">

                                                                <Select
                                                                    value={this.state.selectedOption}  // Bind selected option to state
                                                                    onChange={this.contactListhandler}  // Handle onChange event
                                                                    options={this.state.contactOption}  // Options array
                                                                    isSearchable={true}  // Allow searching in options
                                                                    placeholder="Select Contact List"
                                                                    isClearable={true}  // Optional: allows clearing the selection
                                                                />

                                                            </div>
                                                        ) : (
                                                            <p className="alert alert-danger d-block">
                                                                You don't have any contacts please create{" "}
                                                                <Link to="/dashboard/contact-list">Contacts</Link>{" "}
                                                                and then come back.
                                                            </p>
                                                        )}
                                                    </Tab>
                                                    <Tab label="Upload .xls/.xlsx File">
                                                        <UploadExcelFile setUploadProgress={this.setUploadProgress} sendCsvData={this.getCsvData} setLoading={this.setLoading} />
                                                        <DownloadButton campaignType={this.state.campaignType} countryCode={this.state.country_code} />
                                                    </Tab>

                                                </Tabs>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );

            case 2:
                return (
                    <>
                        <div className="filter-option">
                            <div className="row">
                                <div className="col-md-7">
                                    <p className="d-block mt-4">
                                        Select{" "}
                                        <span className="text-primary">{this.state.channel}</span>{" "}
                                        template to campaign
                                    </p>

                                    {this.state.allWhatsappTemplates.length === 0 ? (
                                        // 🔴 No templates at all
                                        <p className="alert alert-danger d-block">
                                            You don't have any template please create{" "}
                                            <Link to="/dashboard/whatsapp-template-list">
                                                Template
                                            </Link>{" "}
                                            and then come back.
                                        </p>
                                    ) : this.state.WhatsappTemplateList.length === 0 ? (
                                        // 🟡 Templates exist but not for selected brand
                                        <p className="alert alert-warning d-block">
                                            No templates available for selected brand number.
                                            <br />
                                            Please select another brand number or create a template for this brand.
                                        </p>
                                    ) : (
                                        // 🟢 Templates available
                                        <>
                                            <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                                <Select
                                                    value={
                                                        this.state.templteId
                                                            ? {
                                                                value: this.state.templteId,
                                                                label: this.state.templateName
                                                            }
                                                            : null
                                                    }
                                                    onChange={this.selectedWhatsAppTemplate}
                                                    options={this.state.option}
                                                    isSearchable={true}
                                                    placeholder="Select Template"

                                                />
                                            </div>
                                        </>
                                    )}

                                    {this.state.varibaleInTemplate && (
                                        <>
                                            {this.state.campaignType === "3" && <p>Please select column </p>}
                                            {this.state.varibaleInTemplate.some((v) => v !== "mobile") && (
                                                <p className="mb-1" style={{ fontSize: ".75rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase" }}>
                                                    Variables
                                                </p>
                                            )}
                                            {this.state.varibaleInTemplate.map((item, index) => (
                                                <>
                                                    <div key={index} className="input-group mb-2 mr-sm-2">
                                                        {this.state.campaignType === "1" && item !== "mobile" && <div className="input-group-text">{item}</div>}
                                                        {this.state.campaignType === "3" && <div className="input-group-text">{item}</div>}

                                                        {/* Show dropdown if campaignType is "3" */}
                                                        {this.state.campaignType === "3" && (
                                                            <select name={item}
                                                                onChange={item !== "mobile"
                                                                    ? (e) => this.handleMapping(`{{${item}}}`, e.target.value)
                                                                    : this.handleMobileColumnSelect}
                                                                value={item !== "mobile"
                                                                    ? (this.state.variableMapping[`{{${item}}}`] || "")
                                                                    : this.state.mobile_colum}
                                                                disabled={(this.state.showForm1 || this.state.showForm2 || this.state.priority1Data.status || this.state.priority2Data.status)}
                                                                className="form-control">
                                                                <option value="">Select Column</option>
                                                                {this.state.csvHeaders?.map((column, colIndex) => (
                                                                    <option key={colIndex} value={column}>{column}</option>
                                                                ))}
                                                            </select>
                                                        )}

                                                        {/* Skip input for "mobile", otherwise show input if campaignType is "1" */}
                                                        {item !== "mobile" && this.state.campaignType === "1" && (
                                                            <input type="text" name={item} className="form-control"
                                                                placeholder={`Enter variable value`}
                                                                value={this.state.parameter[item] || ''}
                                                                onChange={(e) => this.replaceBodyVal(index, e)} />
                                                        )}
                                                    </div>
                                                    {item !== "mobile" && this.state.campaignType === "1" && (
                                                        <p className="text-danger" style={{ fontSize: ".7rem" }}>Fixed value will be sent to all numbers</p>
                                                    )}
                                                </>
                                            ))}

                                            {/* Dynamic URL call-to-action button(s): mirrors the variable mapping UX above. A template can have up to 2 URL buttons */}
                                            {this.state.dynamicUrlButtons?.length > 0 && (
                                                <>
                                                    <p className="mb-1 mt-2" style={{ fontSize: ".75rem", fontWeight: 600, color: "#6c757d", textTransform: "uppercase" }}>
                                                        {this.state.dynamicUrlButtons.length > 1 ? "Buttons" : "Button"}
                                                    </p>
                                                    {this.state.dynamicUrlButtons.map((btn, btnIndex) => (
                                                        <React.Fragment key={btnIndex}>
                                                            <div className="input-group mb-2 mr-sm-2">
                                                                <div className="input-group-text">{this.getButtonTitle(btn)}</div>

                                                                {this.state.campaignType === "3" && (
                                                                    <select name={`buttonUrlColumn_${btnIndex}`}
                                                                        onChange={(e) => this.handleButtonUrlMapping(btnIndex, e)}
                                                                        value={btn.mappedValue || ""}
                                                                        disabled={(this.state.showForm1 || this.state.showForm2 || this.state.priority1Data.status || this.state.priority2Data.status)}
                                                                        className="form-control">
                                                                        <option value="">Select Column</option>
                                                                        {this.state.csvHeaders?.map((column, colIndex) => (
                                                                            <option key={colIndex} value={column}>{column}</option>
                                                                        ))}
                                                                    </select>
                                                                )}

                                                                {this.state.campaignType === "1" && (
                                                                    <input type="text" name={`buttonUrlValue_${btnIndex}`} className="form-control"
                                                                        placeholder={`Enter variable value`}
                                                                        value={btn.mappedValue || ''}
                                                                        onChange={(e) => this.handleButtonUrlValueChange(btnIndex, e)} />
                                                                )}
                                                            </div>
                                                            {this.state.campaignType === "1" && (
                                                                <p className="text-danger" style={{ fontSize: ".7rem" }}>Fixed value will be sent to all numbers</p>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </>
                                            )}

                                            {this.state.templatePreView?.templateType === "Media" && (
                                                <SetMediaDynamic
                                                    setMediaURL={this.setMediaURL}
                                                    headertext={this.state.templatePreView.headerText}
                                                />
                                            )}

                                            < div className="input group my-3">

                                                <div className="d-flex jusitfy-content-end">
                                                    <button className="btn btn-sm btn-primary"
                                                        disabled={this.state.showForm1}
                                                        // disabled={this.state.showForm1 && this.state.showForm2}
                                                        onClick={this.handleAddForm}>
                                                        <FaPlus /> <span>Add Fallback</span>
                                                    </button>
                                                </div>

                                            </div>

                                            {this.state.showForm1 && <WhatsappFallback
                                                fallback={1}
                                                setFormStatus={(value) => this.setState({ showForm1: value })}
                                                altFormStatus={this.state.showForm2}
                                                priorityData={this.state.priority1Data}
                                                altPriorityData={this.state.priority2Data}
                                                setPriorityData={this.setPriority1Data}
                                                campaignType={this.state.campaignType}
                                                filteredHeaders={this.state.filteredHeaders}
                                                variableMapping={this.state.variableMapping}
                                                platform={this.state.channel}


                                            />}
                                            {this.state.showForm2 && <WhatsappFallback
                                                fallback={2}
                                                setFormStatus={(value) => this.setState({ showForm2: value })}
                                                priorityData={this.state.priority2Data}
                                                altPriorityData={this.state.priority1Data}
                                                setPriorityData={this.setPriority2Data}
                                                campaignType={this.state.campaignType}
                                                filteredHeaders={this.state.filteredHeaders}
                                                variableMapping={this.state.variableMapping}
                                                platform={this.state.channel}

                                            />}
                                        </>
                                    )}

                                    <hr />
                                    {this.state.channel === "whatsapp" &&
                                        this.state.selectedOption
                                        && (
                                            <div className="card p-2">
                                                <p>Contact list data</p>
                                                <div className="table-responsive">
                                                    {this.renderSampleData()}
                                                </div>
                                            </div>
                                        )}
                                    {this.state.countData.length > 0 && <DynamicTable data={this.state.dynamicSampleData} />}



                                    {this.state.showTemplateTypeModal && (
                                        <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content border-danger">

                                                    <div className="modal-header  text-white">
                                                        <h5 className="modal-title">{this.state.templateName}</h5>
                                                        <button
                                                            type="button"
                                                            className="close text-white"
                                                            onClick={() => this.setState({ showTemplateTypeModal: false })}
                                                        >
                                                            <span>&times;</span>
                                                        </button>
                                                    </div>

                                                    <div className="modal-body">
                                                        <div className="alert alert-danger">
                                                            {this.state.templateTypeMessage}
                                                        </div>

                                                        {/* <div className="border rounded p-2 mt-2">
                                                            <div><b>Meta Template Category:</b> {this.state.metaCategory}</div>
                                                            <div><b>Pannel Campaign Category:</b> {this.state.pannelCategory}</div>
                                                        </div> */}

                                                    </div>

                                                    <div className="modal-footer">

                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                this.setState({ showTemplateTypeModal: false });

                                                            }}
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}


                                </div>
                                <div className="col-md-5">
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title mb-0"> Template Preview </h5>
                                        </div>
                                        <hr className="m-0" />
                                        <div className="card-body" >
                                            {this.state.templatePreView ? (
                                                <>
                                                    {this.state.campaignType === "1" && (
                                                        <WhatsAppPreview previewData={this.state.templatePreView} route={this.state.route} />
                                                    )}

                                                    {this.state.campaignType === "3" && (
                                                        this.state.previews.length > 0 ? (
                                                            <Carousel
                                                                autoPlay={false}
                                                                infiniteLoop={true}
                                                                showThumbs={false}
                                                                showArrows={true}
                                                                showStatus={false}
                                                                interval={5000}
                                                                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                                                                    hasPrev && <CustomPrevArrow onClick={onClickHandler} />
                                                                }
                                                                renderArrowNext={(onClickHandler, hasNext, label) =>
                                                                    hasNext && <CustomNextArrow onClick={onClickHandler} />
                                                                }
                                                            >
                                                                {this.state.previews.map((preview, index) => (
                                                                    <WhatsAppPreview key={index} previewData={preview} route={this.state.route} />
                                                                ))}
                                                            </Carousel>
                                                        ) : (
                                                            <WhatsAppPreview previewData={this.state.templatePreView} route={this.state.route} />
                                                        )
                                                    )}

                                                </>
                                            ) : (
                                                <div className="text-center">
                                                    <img className="img-fluid" src={no_data} />
                                                    <p className="text-right">
                                                        Please select {this.state.channel} Template to
                                                        preview
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );

            case 3:
                return (
                    <>
                        <div className="pb-4">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Campaign Name: </strong>
                                            <span className="">{this.state.CampaignName}</span>
                                        </p>
                                    </div>
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Channel Selected : </strong>
                                            <span className="">{this.state.channel}</span>
                                        </p>
                                    </div>
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Campaign Brand Number: </strong>
                                            <span className="">
                                                {this.state.seleted_brand_number}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Campaign Type : </strong>
                                            <span className="">{this.state.campaignType === "1" ? "Normal" : "Custom (Dynamic)"}{" "}Campaign</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Audience : </strong>
                                            {/* <span className="">{this.state.selectedListName}</span> */}
                                            <span className="">{this.state.numbersArray?.length + this.state.countData?.length + this.state.totalCount}</span>
                                        </p>
                                    </div>
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Campaign Template : </strong>
                                            <span className="">
                                                {this.state.templatePreView.tampleName}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Campaign Date : </strong>
                                            <span className="">  {this.state.schedule_datetime
                                                ? this.state.schedule_datetime.replace("T", " ")
                                                : ""}
                                            </span>
                                        </p>
                                    </div>

                                    <div className="campaign-preview">
                                        <p className="m-0">
                                            <strong> Country Code : </strong>
                                            <span className="">{this.state.country_code === 99999 ? "Multi-Country" : this.state.country_code}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="d-flex">
                                <BillableValue
                                    templteId={this.state.templteId}
                                    listId={this.state.listId}
                                    enableCampaingButton={this.enableCampaingButton}
                                />
                            </div> */}
                            <hr />
                            <div className="form-group">
                                <div className="form-check ">
                                    <p className="m-0 d-flex items-align-center">
                                        <input
                                            className="form-check-input mb-1"
                                            defaultValue={this.state.is_schedule}
                                            onChange={this.scheduleHandler}
                                            type="checkbox"
                                            value=""
                                            id="flexCheckDefault"
                                        />
                                        <strong> Campaign Schedule </strong>
                                    </p>
                                </div>
                                <small>
                                    {" "}
                                    Campaign scheduling is the process of specifying the start and
                                    end dates and times for a campaign.
                                </small>
                            </div>
                            {this.state.is_schedule === 1 && (
                                <>
                                    <p className="mt-3 d-block">
                                        Select Date and Time of Campaign
                                    </p>
                                    <div className="input-group w-25 mb-2 mr-sm-2">
                                        <div className="input-group-text">
                                            <FontAwesomeIcon icon={faAddressBook} />
                                        </div>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            onChange={(e) =>
                                                this.setState({ schedule_datetime: e.target.value })
                                            }
                                            placeholder="Example: campaign for digital marketing"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                );

            default:
                return (
                    <div className="filter-option">
                        <div className="row justify-content-start">
                            <div className="col-md-4">
                                <p className="mt-3 d-block">Campaign Channel </p>
                                <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faBroadcastTower} />
                                    </div>
                                    <select
                                        onChange={this.handleChannel}
                                        className="form-control"

                                        value={this.state.channel}

                                    >
                                        <option value="">Select Channel</option>
                                        {this.state.user?.whatsapp_menu === 1 && <option value="whatsapp">WhatsApp</option>}
                                        {this.state.user?.sms_menu === 1 && <option value="sms">SMS</option>}
                                        {this.state.user?.rcs_menu === 1 && <option value="rcs">RCS</option>}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <p className="mt-3 d-block">Select Country </p>
                                <div className="d-flex align-items-center mb-2 mr-sm-2" style={{ flexWrap: "nowrap", width: "100%" }}>
                                    <div className="input-group-text d-flex align-items-center justify-content-center"
                                        style={{ minWidth: "40px", height: "43px", marginBottom: "10px", borderRadius: "0.375rem 0 0 0.375rem" }}>
                                        <FontAwesomeIcon icon={faFlag} />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Select
                                            options={[
                                                ...(this.state.countryList.length > 1
                                                    ? [{ value: "99999", label: "Multi" }]
                                                    : []),
                                                ...this.state.countryList
                                                    .sort((a, b) => a.country_name.localeCompare(b.country_name))
                                                    .map((country) => ({
                                                        value: `${country.country_code}_${country.country_name}`,
                                                        label: `${country.country_name} (${country.country_code})`,
                                                    }))
                                            ]}
                                            value={{
                                                value: this.state.countryList.find(c => c.country_code === this.state.country_code)
                                                    ? `${this.state.country_code}_${this.state.countryList.find(c => c.country_code === this.state.country_code).country_name}`
                                                    : this.state.countryList.length > 1
                                                        ? "99999"
                                                        : "",
                                                label: this.state.countryList.find(c => c.country_code === this.state.country_code)
                                                    ? `${this.state.countryList.find(c => c.country_code === this.state.country_code).country_name} (${this.state.country_code})`
                                                    : this.state.countryList.length > 1
                                                        ? "Multi"
                                                        : "No Country"
                                            }}
                                            onChange={(selectedOption) =>
                                                this.setState({ country_code: Number(selectedOption.value.split("_")[0]) })
                                            }
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "0 0.375rem 0.375rem 0",
                                                    minHeight: "43px"
                                                }),
                                            }}
                                            isSearchable
                                        />
                                    </div>

                                </div>
                            </div>

                            {this.state.user?.whatsapp_menu === 1 && <div className="col-md-4">
                                <p className="mt-3 d-block">Select Brand Number </p>
                                <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faBroadcastTower} />
                                    </div>
                                    <select
                                        onChange={(e) => {
                                            const selectedBrand = e.target.value;

                                            const filteredTemplates = this.state.allWhatsappTemplates.filter(
                                                template => template.brand_number === selectedBrand
                                            );

                                            this.setState({
                                                seleted_brand_number: selectedBrand,
                                                isError: false,
                                                WhatsappTemplateList: filteredTemplates,
                                                option: filteredTemplates.map(item => ({
                                                    value: item.id,
                                                    label: item.temp_name
                                                }))
                                            }, () => {
                                                this.resetTemplateRelatedState();
                                            });
                                        }}


                                        className="form-control"
                                        value={this.state.seleted_brand_number}
                                    >
                                        <option value="">Select Brand Number</option>
                                        {this.state.brandNumberList.map((item, i) => (
                                            <option key={i} value={item.brand_number}>
                                                {item.brand_number}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>}
                            <div className="col-md-6">
                                <p className="mt-3 d-block">Select Campaign Type </p>
                                <div className="input-group drop-down-icons mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faBroadcastTower} />
                                    </div>
                                    <select
                                        value={this.state.campaignType}
                                        onChange={(e) =>
                                            this.handleCampaignType(e)
                                        }
                                        className="form-control"
                                    >
                                        <option value="1"> Normal Campaign </option>
                                        <option value="3"> Custom (Dynamic) campaign</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <p className="mt-3 d-block">Enter Custom Campaign Name</p>
                                <div className="input-group mb-2 mr-sm-2">
                                    <div className="input-group-text">
                                        <FontAwesomeIcon icon={faAddressBook} />
                                    </div>
                                    <input
                                        type="text"
                                        defaultValue={this.state.CampaignName}
                                        className="form-control"
                                        onChange={this.onNameChange}
                                        placeholder="Example: campaign for digital marketing"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <small className="text-primary">
                                        Example : Campaign for remarketing
                                    </small>
                                    <br />
                                    <small
                                        style={{ fontSize: "11px" }}
                                        className={
                                            this.state.CampaignName.length >= 45
                                                ? "text-danger"
                                                : "text-muted"
                                        }
                                    >
                                        {this.state.CampaignName.length}/50 characters
                                    </small>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <p className="mt-3 d-block">Assign Agent</p>
                                <div className="d-flex align-items-center mb-2 mr-sm-2" style={{ flexWrap: "nowrap", width: "100%" }}>
                                    <div className="input-group-text d-flex align-items-center justify-content-center"
                                        style={{ minWidth: "40px", height: "43px", marginBottom: "10px", borderRadius: "0.375rem 0 0 0.375rem" }}>
                                        <FontAwesomeIcon icon={faAddressBook} />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <Select
                                            isMulti
                                            value={
                                                this.state.selectedAgents === "all"
                                                    ? [{ value: "all", label: "✓ All Agents" }]
                                                    : this.state.selectedAgents === "none"
                                                        ? [{ value: "none", label: "⊘ None" }]
                                                        : Array.isArray(this.state.selectedAgents)
                                                            ? this.state.agentList
                                                                .filter(agent => this.state.selectedAgents.includes(agent.id))
                                                                .map(agent => ({
                                                                    value: agent.id,
                                                                    label: `${agent.name}${agent.team_name ? ` - ${agent.team_name}` : ''}`
                                                                }))
                                                            : []
                                            }
                                            onChange={(selectedOptions) => {
                                                if (!selectedOptions || selectedOptions.length === 0) {
                                                    this.setState({ selectedAgents: "none" });
                                                    return;
                                                }

                                                const lastSelected = selectedOptions[selectedOptions.length - 1];

                                                // If last selected is "all" or "none", set as string
                                                if (lastSelected.value === "all") {
                                                    this.setState({ selectedAgents: "all" });
                                                } else if (lastSelected.value === "none") {
                                                    this.setState({ selectedAgents: "none" });
                                                } else {
                                                    // Filter out "all" and "none" from selection and keep individual agents
                                                    const agentIds = selectedOptions
                                                        .filter(opt => opt.value !== "all" && opt.value !== "none")
                                                        .map(opt => opt.value);
                                                    this.setState({ selectedAgents: agentIds });
                                                }
                                            }}
                                            options={[
                                                { value: "all", label: "✓ All Agents" },
                                                { value: "none", label: "⊘ None" },
                                                ...this.state.agentList.map(agent => ({
                                                    value: agent.id,
                                                    label: `${agent.name}${agent.team_name ? ` - ${agent.team_name}` : ''}`,
                                                }))
                                            ]}
                                            isSearchable={true}
                                            placeholder={
                                                this.state.agentList.length === 0
                                                    ? "Loading agents..."
                                                    : "Select Agents"
                                            }
                                            classNamePrefix="react-select"
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={false}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    borderRadius: "0 0.375rem 0.375rem 0",
                                                    minHeight: "43px",
                                                    maxHeight: "120px",
                                                    overflowY: "auto"
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    maxHeight: "100px",
                                                    overflowY: "auto",
                                                }),
                                                multiValue: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.data.value === "all"
                                                        ? "#d1fae5"
                                                        : state.data.value === "none"
                                                            ? "#fee2e2"
                                                            : "#e7f5ff",
                                                }),
                                                multiValueLabel: (provided, state) => ({
                                                    ...provided,
                                                    color: state.data.value === "all"
                                                        ? "#198754"
                                                        : state.data.value === "none"
                                                            ? "#dc3545"
                                                            : "#1971c2",
                                                    fontWeight: state.data.value === "all" || state.data.value === "none"
                                                        ? "bold"
                                                        : "normal",
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    fontWeight: state.data.value === "all" || state.data.value === "none"
                                                        ? "bold"
                                                        : "normal",
                                                    color: state.data.value === "none"
                                                        ? "#dc3545"
                                                        : state.data.value === "all"
                                                            ? "#198754"
                                                            : provided.color,
                                                }),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                );
        }
    };

    render() {

        const { campaignAllowed, showRechargePopup } = this.state;

        return (
            <div className="wrapper">
                <Helmet>
                    <style type="text/css">{`
         .whatsapp ul {
            display:none!important;
          }
        `}</style>
                </Helmet>

                {this.state.isLoading && (this.state.uploadProgress === 0) && <Spining />}
                {this.state.isLoading &&
                    (this.state.uploadProgress >= 100) &&
                    <div className={`${style.spinnerContainer} ${style.animatedText}`}>
                        <p>Processing...</p>
                        <p>Please do not leave or refresh the page</p>

                    </div>
                }
                {this.state.isLoading &&
                    this.state.uploadProgress !== 0 &&
                    this.state.uploadProgress < 100 &&
                    <div className={style.spinnerContainer}>
                        <div className={style.spinnerWrapper}>
                            <div className={style.spinner}></div>
                            <div className={style.percentage}>
                                {this.state.uploadProgress}%
                            </div>
                            <p className={style.uploadText}>Uploading file</p>
                        </div>
                    </div>

                }
                {this.state.showModal && <BillableModal
                    billable={this.state.billable}
                    nonbillable={this.state.not_billable}
                    onClose={this.handleModalClose}
                    error={
                        {
                            messageType: this.state.messageType,
                            isError: this.state.isError,
                            errorMessage: this.state.errorMessage,
                        }}
                    clearError={this.clearError}
                />}
                <DashboardLeftMenu />
                <div className="main">
                    <DashboardHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className=" mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3>
                                        <strong>WhatsApp Campaign </strong>
                                    </h3>
                                </div>
                            </div>
                            <div className="">
                                <div className="card">
                                    <div className="card-body">
                                        <div id="msform" style={{ zIndex: "1", position: 'relative' }}>
                                            <ul id="progressbar">
                                                {this.state.step === 0 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li>Choose Audience </li>
                                                        <li>Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 1 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience</li>
                                                        <li>Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 2 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience </li>
                                                        <li className="active">Campaign Template </li>
                                                        <li> Preview Campaign </li>
                                                    </>
                                                ) : this.state.step === 3 ? (
                                                    <>
                                                        <li className="active">Campaign Details</li>
                                                        <li className="active">Choose Audience </li>
                                                        <li className="active">Campaign Template </li>
                                                        <li className="active"> Preview Campaign </li>
                                                    </>
                                                ) : null}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {this.state.isError && this.state.messageType === "alert-danger" && (
                                    <Alert type={this.state.messageType} clearError={this.clearError}>
                                        {this.state.errorMessage}
                                    </Alert>
                                )}

                                <div className="card">
                                    <div className="card-body campaign-box">
                                        {this.formRender()}

                                        <hr />

                                        <div className="row justify-content-center">
                                            <div className="col-md-4 mb-3">
                                                <button
                                                    disabled={this.state.step === 0}
                                                    onClick={() => this.prevStep()}
                                                    className={
                                                        this.state.step === 0
                                                            ? "btn btn-block btn-secondary"
                                                            : "btn btn-block btn-primary"
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faArrowCircleLeft} /> Previous
                                                </button>
                                            </div>
                                            <div className="col-md-4">
                                                {this.state.step === 3 ? (
                                                    <button
                                                        onClick={this.createCampaign}
                                                        className="btn btn-block btn-info"
                                                        disabled={this.state.isLoading}
                                                    >
                                                        <FontAwesomeIcon icon={faCheckCircle} /> Start
                                                        Campaign
                                                    </button>
                                                ) : (
                                                    <button
                                                        disabled={
                                                            this.state.isError ||
                                                            (this.state.campaignType === "3"
                                                                ? this.state.step === 1 &&
                                                                this.state.dynamicSampleData.length === 0 && !this.state.selectedOption
                                                                : this.state.step === 1 &&
                                                                (this.state.csvHeaders.length === 0 &&
                                                                    this.state.textnumbers === "" &&
                                                                    !this.state.selectedOption
                                                                )) || (this.state.step === 2 && this.state.templteId === "")
                                                        }
                                                        onClick={() => this.nextStep()}
                                                        className="btn btn-block btn-primary"
                                                    >
                                                        Next <FontAwesomeIcon icon={faArrowCircleRight} />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <DashboardFooter />
                </div>
            </div>

        );
    }
}

class CustomPrevArrow extends Component {
    render() {
        return (
            <button
                onClick={this.props.onClick}
                style={{
                    position: "absolute",
                    top: "50%",
                    left: "-1%",
                    transform: "translateY(-50%)",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "30px",
                    zIndex: "1",
                }}
            >
                &#10094; {/* Unicode for left arrow */}
            </button>
        );
    }
}

class CustomNextArrow extends Component {
    render() {
        return (
            <button
                onClick={this.props.onClick}
                style={{
                    position: "absolute",
                    top: "50%",
                    right: "-1%",
                    transform: "translateY(-50%)",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "black",
                    fontSize: "30px",
                    zIndex: "1",
                }}
            >
                &#10095; {/* Unicode for right arrow */}
            </button>
        );
    }
}

export default withRouter(TestWhatsAppCampaign);